module.exports = __webpack_public_path__ + "media/icons/flag-818692bb.svg";